import { lazyVue } from "@/utils";
export default [
  {
    path: "/orderList",
    name: "orderList",
    title: "订单",
    component: lazyVue("orderList/index"),
    meta: {
      showBar: 1,
      title: "订单",
      name: "订单"
    }
  },
  {
    path: "/orderDetail",
    name: "orderDetail",
    title: "订单详情",
    component: lazyVue("orderList/components/orderDetail"),
    meta: {
      // showBar:1,
      isKeepAlive: true,
      title: "订单详情",
      name: "订单详情"
    }
  },
  {
    path: "/waitPayOrderDetail",
    name: "waitPayOrderDetail",
    title: "订单详情",
    component: lazyVue("orderList/components/waitPayOrderDetail"),
    meta: {
      // showBar:1,
      isKeepAlive: true,
      title: "订单详情",
      name: "订单详情"
    }
  }
];



// WEBPACK FOOTER //
// ./src/router/orderList/index.js